import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardTitle, Button, Image } from '@thd-olt-component-react/core-ui';
import { ApplyNowModal } from '../apply-now-modal/apply-now-modal.component';
import { clickEvent, impressionEvent } from '../publisher';
import { cardImageUrl, defaultApplyNowLink } from '../plccUtils';
import '../PrivateLabelCreditCard.scss';
import { getIntroOfferLink, loadEstimatorScript } from '../utils';

const ApplyNow = ({ paymentEstimatorVersion, isMobile }) => {
  const [applyNowLink, setApplyNowLink] = useState(defaultApplyNowLink);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const analyticsInteraction = () => {
    clickEvent('plcc-apply now');
  };

  useEffect(() => {
    loadEstimatorScript(
      paymentEstimatorVersion,
      () => setApplyNowLink(getIntroOfferLink(isMobile, 'homepage')),
      isMobile
    );
    impressionEvent('plcc-apply now');
  }, []);

  const applyNowMessage = () => {
    return (
      <>
        <div className="u__text-align--center">
          <Image
            src={cardImageUrl.PLCN_HOMEDEPOT}
            className="u--padding"
            alt="Credit Card Icon"
            height="50"
            width="80"
          />
        </div>
        <h3 className="u__medium u__text-align--center u__bold u--paddingTop">
          Get The Card, Get Up to $100 Off*
        </h3>
        <p className="u--paddingTop u--paddingBottom">
          +6-months everyday financing on purchases over $299* on your
          qualifying purchase when you open a Home Depot Credit Card.
        </p>
        <div className="u--paddingTop u--paddingBottom">
          <Button tag="a" href={applyNowLink} onClick={analyticsInteraction} outline dark>
            Apply Now
          </Button>
        </div>
      </>
    );
  };

  return (
    <>
      <CardTitle title="Home Depot Credit Card Offers" />
      <CardContent>
        {showModal && (
          <ApplyNowModal
            applyNowUrl={applyNowLink}
            closeModal={closeModal}
            analyticsFeature="plcc-apply now"
            isMobile={isMobile}
          />
        )}
        <div className="plcc-card">
          {applyNowMessage()}
          <p className="u__text-align--center">
            See{' '}
            <button
              className="u__default-link legal-click"
              onClick={openModal}
              type="button"
            >
              Terms & Conditions
            </button>{' '}
            for offer details.
          </p>
        </div>
      </CardContent>
    </>
  );
};

ApplyNow.propTypes = {
  paymentEstimatorVersion: PropTypes.string,
  isMobile: PropTypes.bool,
};
ApplyNow.defaultProps = {
  paymentEstimatorVersion: 'v1.0.29',
  isMobile: false,
};

export default ApplyNow;
